var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var ProfileImage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #d0dbe1;\n  border: 1px solid #d0dbe1;\n  background-image: ", ";\n  background-size: cover;\n  border-radius: 50%;\n  flex-shrink: 0;\n  height: 198px;\n  width: 198px;\n"], ["\n  background-color: #d0dbe1;\n  border: 1px solid #d0dbe1;\n  background-image: ", ";\n  background-size: cover;\n  border-radius: 50%;\n  flex-shrink: 0;\n  height: 198px;\n  width: 198px;\n"])), function (_a) {
    var logoImg = _a.logoImg;
    return (logoImg ? "url(" + logoImg + ")" : "url()");
});
var templateObject_1;
//# sourceMappingURL=ProfileImage.js.map